export const tokenStorageItemKey = 'mx.auth.session.token';
export const redirectUriStorageItemKey = 'mx.auth.redirect.uri';
export const codeVerifierStorageItemKey = 'mx.auth.code_verifier';
export const localStorageSignOutKey = 'mx.login.signout';
